import { createFileRoute, Link, Outlet, redirect, useRouteContext } from '@tanstack/react-router'
import { Button } from '@/components/ui/button'
import { LogOut } from 'lucide-react'

export const Route = createFileRoute('/_protected')({
  component: RouteComponent,
  async beforeLoad({ context: { auth } }) {
    if (auth.status === 'pending') {
      const data = await auth.ensureData();
      if (!data) {
        throw redirect({
          to: "/login",
        });
      }
    } else {
      if (auth.status === 'unauthenticated') {
        throw redirect({
          to: "/login",
        });
      }
    }
  }
})

function RouteComponent() {
  const { auth } = useRouteContext({ from: '/_protected' })
  const isAdmin = auth.username === 'admin'

  const handleLogout = async () => {
    await auth.logout()
    window.location.href = '/login'
  }

  return (
    <div className="min-h-screen flex flex-col">
      <nav className="border-b bg-background px-6 py-3 flex gap-6 items-center">
        <span className="font-semibold text-primary">Zona WiFi</span>
        <Link
          to="/dashboard"
          className="text-sm text-muted-foreground hover:text-foreground transition-colors [&.active]:font-semibold [&.active]:text-foreground"
        >
          Dashboard
        </Link>
        <Link
          to="/portal-cautivo"
          className="text-sm text-muted-foreground hover:text-foreground transition-colors [&.active]:font-semibold [&.active]:text-foreground"
        >
          Portal Cautivo
        </Link>
        {isAdmin && (
          <Link
            to="/admin"
            className="text-sm text-muted-foreground hover:text-foreground transition-colors [&.active]:font-semibold [&.active]:text-foreground"
          >
            Administración
          </Link>
        )}
        <div className="ml-auto flex items-center gap-3">
          <span className="text-sm text-muted-foreground">{auth.username}</span>
          <Button size="sm" onClick={handleLogout} className="cursor-pointer bg-black text-white hover:bg-zinc-800 gap-1.5">
            <LogOut className="h-4 w-4" />
            Cerrar sesión
          </Button>
        </div>
      </nav>
      <main className="flex-1">
        <Outlet />
      </main>
    </div>
  )
}
